import React from "react";

const MyWalletItem = () => {
    const walletItem = [1,2,3,4];
    return (
        <>
            <div className="_wallet_top_table_wrap">
                {
                    walletItem.map((item,id) =>
                        <div className="_wallet_top_table_item_wrap">
                            <div className="row align-items-center">
                                <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                    <div className="_wallet_top_table_left">
                                        <img src={`assets/img/chain${item}.png`} alt="pic" className="_wallet_top_table_left_img" />
                                        <div className="_wallet_top_table_left_right">
                                            <p className="_wallet_top_table_left_right_txt">Ethereum</p>
                                            <h5 className="_wallet_top_table_left_right_title">10 ETH</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                                    <button className="btn dropdown-toggle _wallet_top_table_right_btn" type="button" id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                        <div className="_wallet_top_table_right_btn_wrap">
                                            <img src="assets/img/fox.svg" alt="pic" className="_wallet_top_table_right_btn_img" />
                                            <p className="_wallet_top_table_right_btn_txt">0xeaf6c2eae09b5e79d...0bg8</p>
                                        </div>
                                    </button>
                                    <ul className="dropdown-menu _wallet_top_table_right_btn_drop" aria-labelledby="defaultDropdown">
                                        <li><a className="dropdown-item _wallet_right_btn_drop_item" href="#0">
                                            <div className="_wallet_top_table_right_btn_wrap">
                                                <img src="assets/img/fox.svg" alt="pic" className="_wallet_top_table_right_btn_img" />
                                                <p className="_wallet_top_table_right_btn_txt">0xeaf6c2eae09b5e79d...0bg8
                                                </p>
                                                <img src="assets/img/checkvec.svg" alt="pic" className="_wallet_top_table_right_btn_drop_ic" />
                                            </div>
                                        </a>
                                        </li>
                                        <li><a className="dropdown-item _wallet_right_btn_drop_item" href="#0">
                                            <div className="_wallet_top_table_right_btn_wrap">
                                                <img src="assets/img/fox.svg" alt="pic" className="_wallet_top_table_right_btn_img" />
                                                <p className="_wallet_top_table_right_btn_txt">0xeaf6c2eae09b5e79d...0bg8
                                                </p>
                                                <img src="assets/img/checkvec.svg" alt="pic" className="_wallet_top_table_right_btn_drop_ic" />
                                            </div>
                                        </a>
                                        </li>
                                        <li><a className="dropdown-item _wallet_right_btn_drop_item" href="#0">
                                            <div className="_wallet_top_table_right_btn_wrap">
                                                <img src="assets/img/fox.svg" alt="pic" className="_wallet_top_table_right_btn_img" />
                                                <p className="_wallet_top_table_right_btn_txt">0xeaf6c2eae09b5e79d...0bg8
                                                </p>
                                                <img src="assets/img/checkvec.svg" alt="pic" className="_wallet_top_table_right_btn_drop_ic" />
                                            </div>
                                        </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        )
                }
            </div>
        </>
    )
}

export default MyWalletItem;